import React from 'react';
import {
  SlidersHorizontal,
  User,
  Volume2,
  Wand2,
  Loader2,
  Coins,
} from 'lucide-react';

export function VoiceControls({
  selectedVoice,
  setSelectedVoice,
  voiceOptions,
  speechRate,
  setSpeechRate,
  pitch,
  setPitch,
  volume,
  setVolume,
  isGenerating,
  isProcessingAudio,
  canGenerate,
  onGenerate,
}) {
  const isBusy = isGenerating || isProcessingAudio;

  return (
    <div className="space-y-4">
      <div className="bg-white rounded-2xl border border-gray-100 p-5 shadow-sm">
        <div className="flex items-center gap-2 mb-4">
          <SlidersHorizontal size={18} className="text-purple-600" />
          <h3 className="font-bold text-gray-800">声音调节</h3>
        </div>

        <div className="space-y-4">
          {/* 选择音色 */}
          <div>
            <label className="text-sm font-medium text-gray-700 mb-1.5 flex items-center gap-1.5">
              <User size={14} /> 选择音色
            </label>
            <select
              value={selectedVoice}
              onChange={(e) => setSelectedVoice(e.target.value)}
              className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-200"
            >
              {voiceOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>

          {/* 语速 */}
          <div>
            <div className="flex justify-between text-sm mb-1.5">
              <span className="text-gray-700 font-medium">语速</span>
              <span className="text-gray-500">{speechRate.toFixed(1)}x</span>
            </div>
            <input
              type="range"
              min={0.3}
              max={2}
              step={0.1}
              value={speechRate}
              onChange={(e) => setSpeechRate(parseFloat(e.target.value))}
              className="w-full accent-purple-600"
            />
            <div className="flex justify-between text-[11px] text-gray-400 mt-0.5">
              <span>慢</span>
              <span>快</span>
            </div>
          </div>

          {/* 音调 */}
          <div>
            <div className="flex justify-between text-sm mb-1.5">
              <span className="text-gray-700 font-medium">音调</span>
              <span className="text-gray-500">{pitch.toFixed(1)}</span>
            </div>
            <input
              type="range"
              min={0.3}
              max={2}
              step={0.1}
              value={pitch}
              onChange={(e) => setPitch(parseFloat(e.target.value))}
              className="w-full accent-purple-600"
            />
            <div className="flex justify-between text-[11px] text-gray-400 mt-0.5">
              <span>低</span>
              <span>高</span>
            </div>
          </div>

          {/* 音量 */}
          <div>
            <div className="flex justify-between text-sm mb-1.5">
              <span className="text-gray-700 font-medium flex items-center gap-1">
                <Volume2 size={14} /> 音量
              </span>
              <span className="text-gray-500">{Math.round(volume * 100)}%</span>
            </div>
            <input
              type="range"
              min={0}
              max={1}
              step={0.05}
              value={volume}
              onChange={(e) => setVolume(parseFloat(e.target.value))}
              className="w-full accent-purple-600"
            />
          </div>

          {/* 合成语音按钮 */}
          <button
            onClick={onGenerate}
            disabled={isBusy || !canGenerate}
            className="w-full py-3 rounded-xl bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold shadow-md hover:from-purple-700 hover:to-pink-700 disabled:opacity-50 disabled:cursor-not-allowed transition flex items-center justify-center gap-2"
          >
            {isGenerating ? (
              <Loader2 size={18} className="animate-spin" />
            ) : isProcessingAudio ? (
              <Loader2 size={18} className="animate-spin" />
            ) : (
              <Wand2 size={18} />
            )}
            {isGenerating
              ? '生成中'
              : isProcessingAudio
                ? '处理中'
                : '合成语音'}
            {!isBusy && (
              <span className="inline-flex items-center gap-1 text-xs bg-white/20 px-2 py-0.5 rounded-full">
                <Coins size={12} /> -1 积分
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
